// ============================================================
// หน้า RecordBillHistory — ข้อมูลการออกใบแจ้งหนี้อื่นๆ (ประวัติ)
// ------------------------------------------------------------
// ดูรายการใบแจ้งหนี้อื่น ๆ ที่เคยออกไว้ และสั่งพิมพ์ซ้ำได้
// คู่กับหน้า RecordBill ที่เป็นหน้าออกใบใหม่
//
// ⚠️ ตัวกรอง "บ้านเลขที่" ยังไม่มีตัวเลือกให้เลือก (data_address ไม่เคยถูกโหลด)
//    คงไว้ตามพฤติกรรมเดิม — ถ้าต้องการใช้งานจริงต้องโหลดรายชื่อบ้านเลขที่มาเติม
// ============================================================

import React, { Component } from "react";
import Select from "react-select";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import { tokens, select_style, toFixed, GET, format_date, getStorage, loading, permission, Paginate, openDocument, buildInvoiceOtherData } from "../../shared/index.js";

// หน้านี้ใช้สิทธิ์เดียวกับเมนูข้อมูลการใช้น้ำ (ตามของเดิม)
const perm = permission("record-water-usage");

export default class RecordBillHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      filter_address_number: null,
      data: null,
      data_address: [], // ตัวเลือกบ้านเลขที่ (ยังไม่มีการโหลดข้อมูลมาเติม)
    };
  }

  async componentDidMount() {
    loading(false);
    if (perm.view) await this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    const { filter_address_number, page } = this.state;
    const result = await GET(tokens, `v1/TH/record-other/filter-search/page/${page}/${getStorage("project_id")}`, { address_number: filter_address_number?.value || "" });
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  // พิมพ์ใบแจ้งหนี้ซ้ำจากรายการที่เลือก
  printReceipt = (item) => {
    openDocument(
      "/doc/invoice-other",
      buildInvoiceOtherData({
        full_name: item.full_name,
        address: item.address || item.address_number,
        iw_number: item.iw_number,
        record_date: item.record_date,
        title: item.title,
        cost: item.cost,
      })
    );
  };

  render() {
    const { data, filter_address_number, data_address, page } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลการใช้น้ำ" />

        <div className="body p-3">
          <div className="card border-0 p-3">
            {/* หัวข้อ + ปุ่มย้อนกลับไปหน้าออกใบใหม่ */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h4 className="mb-0">
                <b>ข้อมูลการออกใบแจ้งหนี้อื่นๆ</b>
              </h4>
              <button className="btn btn-outline-primary px-4 mx-1" onClick={() => (window.location.href = "/record-bill")}>
                ย้อนกลับ
              </button>
            </div>

            {/* ตัวกรอง */}
            {perm.view && (
              <div className="d-flex align-items-center mb-3">
                <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_address} value={filter_address_number} onChange={(e) => this.setState({ filter_address_number: e })} />
                <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                  ค้นหา
                </button>
                <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>
                  รีเซ็ท
                </button>
              </div>
            )}

            {/* ตารางรายการ */}
            <div className="table-responsive">
              <table className="table table-borderless table-striped text-nowrap">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th className="text-center">เลขที่ใบแจ้งหนี้</th>
                    <th className="text-center">ชื่อ</th>
                    <th className="text-center">ชื่อหน่วยงาน</th>
                    <th className="text-center">ที่อยู่</th>
                    <th className="text-left">วันที่บันทึก</th>
                    <th className="text-center">รายการ</th>
                    <th className="text-center">รวมเป็นเงิน</th>
                    <th className="text-center">พิมพ์ใบเสร็จ</th>
                  </tr>
                </thead>
                <tbody>
                  {!data?.data?.length ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        ไม่มีข้อมูล
                      </td>
                    </tr>
                  ) : (
                    data.data.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{item.iw_number || "-"}</td>
                        <td className="text-start text-nowrap">{item.full_name || "-"}</td>
                        <td className="text-start text-nowrap">{item.agency_name || "-"}</td>
                        <td className="text-start text-nowrap">{item.address_number || "-"}</td>
                        <td className="text-center">{item.record_date ? format_date(item.record_date, "dd/mm/yyyy") : "-"}</td>
                        <td className="text-start text-nowrap">{item.title || "-"}</td>
                        <td className="text-right">{item.cost ? toFixed(item.cost) : "0.00"}</td>
                        <td className="text-center">
                          {/* ปุ่มพิมพ์ (ไอคอนเครื่องพิมพ์) */}
                          <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-inline-flex align-items-center justify-content-center m-0 pointer" onClick={() => this.printReceipt(item)}>
                            <i className="icon text-primary">&#xf02f;</i>
                          </label>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <Paginate className="d-flex justify-content-between align-items-center w-100 mt-2" data={data} page={page} onChange={(value) => this.setState({ page: value }, this.GetAll)} />
          </div>
        </div>
      </div>
    );
  }
}
